import { datadogRum } from '@datadog/browser-rum'
import { ServerDataShape } from '../utils/server-data'

const getDDTraceLink = (environment: string, correlationId: string) => {
  switch (environment) {
    case 'production':
    case 'live':
      return `https://go/ddprod/trace?${correlationId}`
    case 'sandbox':
      return `https://go/ddsb/trace?${correlationId}`
    default:
      return `https://go/ddqa/trace?${correlationId}`
  }
}

const getCalLogLink = (environment: string, correlationId: string) => {
  switch (environment) {
    case 'production':
    case 'live':
      return `https://go/ddprod/tocal?${correlationId}`
    case 'sandbox':
      return `https://go/ddsb/tocal?${correlationId}`
    default:
      return `https://go/ddqa/tocal?${correlationId}`
  }
}

export const addCorrelationIdToContext = (
  event: any,
  env: string,
  correlationId: string,
) => {
  if (correlationId) {
    event.context.correlationId = correlationId
    event.context['dd-trace-url'] = getDDTraceLink(env, correlationId)
    event.context['external-cal-url'] = getCalLogLink(env, correlationId)
  }
}

export const initRum = (serverData: ServerDataShape) => {
  if (serverData?.datadog) {
    const env = serverData?.env?.toLowerCase() || 'development'
    const correlationId = serverData?.calId || ''

    datadogRum.init({
      applicationId: serverData?.datadog?.applicationId,
      clientToken: serverData?.datadog?.clientToken,
      site: serverData?.datadog?.site,
      service: 'consumerappnodeweb',
      env,
      version: APP_VERSION || '<UNDEFINED>',
      // sampling must be set at 100 for session and 0 for recording. retention will be controlled on the backend in Datadog
      sessionSampleRate: 100,
      sessionReplaySampleRate: 0,
      // auto-instrumentations
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      // privacy defaults to prevent leaking PII
      defaultPrivacyLevel: 'mask',
      enablePrivacyForActionName: true,
      // exclude log, tealeaf, and fpti endpoints which are not tied to user interactions from activity tracking
      excludedActivityUrls: [/log/i, /fpti/i, /tealeaf/i, /tracking\/ts/i],
      // exclude log, tealeaf, and fpti endpoints which are not tied to user interactions from universal tracing
      allowedTracingUrls: [
        (url: string) =>
          !(
            url.includes('log') ||
            url.includes('fpti') ||
            url.includes('tealeaftarget') ||
            url.includes('tracking/ts')
          ) && url.includes('paypal.com'),
      ],
      beforeSend: (event: any) => {
        // modify RUM events to include the correlationId and links to logs and traces
        // for the request because we don't yet have universal tracing
        addCorrelationIdToContext(event, env, correlationId)
        return true
      },
    })
    datadogRum.setUser({
      id: serverData?.ppRef,
      locale: serverData?.locality?.locale,
      country: serverData?.locality?.country,
      isLoggedIn: serverData?.isLoggedIn,
    })
    datadogRum.setViewContextProperty('page', {
      name: serverData?.content?.viewName,
      message: serverData?.content?.id,
      isRebrand: serverData?.content?.isRedesign,
      theme: serverData?.content?.theme,
      isSmsWidget: serverData?.content?.isSms,
      queryParams: { ...serverData?.nonPiiQueryParams },
    })
  }
}
